import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import TriggerDataLoggerComponent from './TriggerDataLoggerComponent';
import { getModel } from '../selectors';
import * as actions from '../actions';

const TriggerDataLoggerContainer = (props) => {
	return <TriggerDataLoggerComponent {...props}/>;
};

const mapStateToProps = (state) => {
	const model = getModel(state);
	return { model };
};

const mapDispatchToProps = (dispatch) => {
	return {
		actions: bindActionCreators(actions, dispatch)
	};
};

const TriggerDataLoggerContainerConn = connect(
	mapStateToProps,
	mapDispatchToProps
)(TriggerDataLoggerContainer);

export default TriggerDataLoggerContainerConn;
